const CONSENT_COOKIE = "mon-hr-analytics-consent"
const TRACKING_ID = "G-H4DTYZFPJJ"
const CONFIRMED_COOKIE = "mon-hr-newsletter-confirmed"

// Dependencies are explicit so consent and withdrawal can be tested without Google.
function createAnalytics({ window, document, enabled }) {
  let initialized = false
  let lastPagePath = null
  const cleanUrl = value => {
    try {
      const url = new URL(value)
      return /^https?:$/.test(url.protocol) ? `${url.origin}${url.pathname}` : ""
    } catch { return "" }
  }
  const optedIn = () => document.cookie.split(";").some(
    cookie => cookie.trim() === `${CONSENT_COOKIE}=true`
  )
  const getConsent = () => {
    if (optedIn()) return true
    return document.cookie.split(";").some(
      cookie => cookie.trim() === `${CONSENT_COOKIE}=false`
    ) ? false : null
  }
  const doNotTrack = () => window.navigator.doNotTrack === "1" || window.doNotTrack === "1"

  function initialize() {
    if (!enabled || !optedIn() || doNotTrack()) return false
    if (initialized) return true
    initialized = true
    window[`ga-disable-${TRACKING_ID}`] = false
    window.dataLayer = window.dataLayer || []
    window.gtag = function () { window.dataLayer.push(arguments) }
    window.gtag("consent", "default", {
      analytics_storage: "granted", ad_storage: "denied",
      ad_user_data: "denied", ad_personalization: "denied",
    })
    window.gtag("js", new Date())
    window.gtag("config", TRACKING_ID, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      cookie_flags: "SameSite=Lax;Secure",
      page_location: `${window.location.origin}${window.location.pathname}`,
      page_referrer: cleanUrl(document.referrer),
    })
    const script = document.createElement("script")
    script.id = "mon-hr-analytics"
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`
    document.head.appendChild(script)
    return true
  }

  function trackPageView() {
    if (!initialize()) {
      clearAnalyticsCookies()
      return false
    }
    // Query strings and hashes can contain visitor data and are not needed here.
    const path = window.location.pathname
    if (path !== lastPagePath) {
      const page = {
        page_path: path,
        page_location: `${window.location.origin}${path}`,
        page_title: document.title,
        page_referrer: lastPagePath
          ? `${window.location.origin}${lastPagePath}`
          : cleanUrl(document.referrer),
      }
      // Custom and automatic engagement events inherit the same clean URL.
      window.gtag("set", page)
      window.gtag("event", "page_view", page)
      lastPagePath = path
    }
    if (path === "/newsletter/confirmado/" && document.cookie.split(";").some(
      cookie => cookie.trim() === `${CONFIRMED_COOKIE}=1`
    )) {
      clearConfirmationMarker()
      window.gtag("event", "newsletter_subscription_confirmed")
    }
    return true
  }

  function trackSignupRequest() {
    if (trackPageView()) window.gtag("event", "newsletter_signup_requested")
  }

  function trackContactClick(method) {
    if (!["email", "linkedin"].includes(method)) return
    if (trackPageView()) window.gtag("event", "contact_click", { contact_method: method })
  }

  function clearConfirmationMarker() {
    document.cookie = `${CONFIRMED_COOKIE}=; Max-Age=0; Path=/newsletter/confirmado/; SameSite=Lax${window.location.protocol === "https:" ? "; Secure" : ""}`
  }

  function clearAnalyticsCookies() {
    clearConfirmationMarker()
    const hostname = window.location.hostname
    const domains = [""]
    if (!/^[\d.]+$/.test(hostname)) {
      const parts = hostname.split(".")
      for (let i = 0; i < parts.length - 1; i++) domains.push(`; Domain=.${parts.slice(i).join(".")}`)
    }
    for (const entry of document.cookie.split(";")) {
      const name = entry.trim().split("=")[0]
      if (!/^(_ga(?:_|$)|_gid$|_gat(?:_|$))/.test(name)) continue
      for (const domain of domains) {
        document.cookie = `${name}=; Max-Age=0; Path=/${domain}; SameSite=Lax`
      }
    }
  }

  function setConsent(accepted) {
    document.cookie = `${CONSENT_COOKIE}=${accepted ? "true" : "false"}; Max-Age=12960000; Path=/; SameSite=Lax${window.location.protocol === "https:" ? "; Secure" : ""}`
    if (accepted) {
      trackPageView()
      return
    }
    window[`ga-disable-${TRACKING_ID}`] = true
    if (typeof window.gtag === "function") window.gtag("consent", "update", { analytics_storage: "denied" })
    clearAnalyticsCookies()
    document.getElementById("mon-hr-analytics")?.remove()
    // Reload after withdrawal to unload any previously running third-party code.
    if (initialized) window.location.reload()
  }

  return { getConsent, setConsent, trackPageView, trackSignupRequest, trackContactClick, doNotTrack }
}

let browserAnalytics
function getAnalytics() {
  if (typeof window === "undefined") return null
  if (!browserAnalytics) browserAnalytics = createAnalytics({
    window, document, enabled: process.env.NODE_ENV === "production",
  })
  return browserAnalytics
}

module.exports = { CONSENT_COOKIE, CONFIRMED_COOKIE, TRACKING_ID, createAnalytics, getAnalytics }
